<template>
  <div class="resume-section projects-section">
    <h2 class="section-heading" :style="headingStyle">Projects</h2>
    <div v-for="(item, index) in section.data.items" :key="index" class="entry">
      <h3 class="entry-title">
        {{ item.name || 'Project Name' }}
        <a
          v-if="item.url"
          :href="item.url"
          target="_blank"
          rel="noopener noreferrer"
          class="entry-link"
          :style="{ color: themeColor }"
        >
          View
        </a>
      </h3>
      <p class="entry-desc">{{ item.description || 'Project description' }}</p>
      <p v-if="item.technologies" class="entry-tech">
        <span class="entry-tech__label">Stack</span>
        {{ item.technologies }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    themeColor: {
      type: String,
      default: '#0f766e'
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headingStyle() {
      return {
        color: this.themeColor,
        borderColor: this.themeColor,
      }
    }
  }
}
</script>

<style scoped>
.section-heading {
  font-family: var(--ps-font-display);
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  border-bottom: 2px solid;
  padding-bottom: 0.45rem;
  margin-bottom: 1rem;
}

.entry + .entry {
  margin-top: 1rem;
}

.entry-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
  margin-bottom: 0.3rem;
}

.entry-link {
  margin-left: 0.5rem;
  font-size: 0.8rem;
  font-weight: 600;
  text-decoration: none;
}

.entry-link:hover {
  text-decoration: underline;
}

.entry-desc {
  color: #334155;
  font-size: 0.9rem;
  line-height: 1.55;
  margin-bottom: 0.35rem;
}

.entry-tech {
  font-size: 0.8rem;
  color: #64748b;
}

.entry-tech__label {
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-right: 0.35rem;
  color: #475569;
}
</style>
